import { render, staticRenderFns } from "./reservationPay.vue?vue&type=template&id=6644650d&scoped=true"
import script from "./reservationPay.vue?vue&type=script&lang=js"
export * from "./reservationPay.vue?vue&type=script&lang=js"
import style0 from "./reservationPay.vue?vue&type=style&index=0&id=6644650d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644650d",
  null
  
)

export default component.exports